import { cva } from 'class-variance-authority';

export const triggerVariants = cva(
  [
    'group',
    'fill-current',
    'flex',
    'flex-1',
    'items-center',
    'justify-between',
    '[&[data-state=open]>svg]:rotate-180',
    // common lib overrides are giving the button a default border on focus
    // we need to remove it.
    'focus-visible:outline-none',
    'focus:outline-none',
  ],
  {
    variants: {
      size: {
        small: [
          'py-spacing-comp-accordion-small-vertical',
          'px-spacing-comp-accordion-small-horizontal',
          'gap-spacing-comp-accordion-small-gap',
        ],
        medium: [
          'py-spacing-comp-accordion-medium-vertical',
          'px-spacing-comp-accordion-medium-horizontal',
          'gap-spacing-comp-accordion-medium-gap',
        ],
      },
    },
    defaultVariants: {
      size: 'medium',
    },
  },
);
